const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  let os = "Unknown OS";
  let browser = "Unknown Browser";
  let deviceType = "Unknown Device";

  if (/Windows/i.test(userAgent)) os = "Windows";
  else if (/Mac/i.test(userAgent)) os = "MacOS";
  else if (/Android/i.test(userAgent)) os = "Android";
  else if (/iPhone|iPad/i.test(userAgent)) os = "iOS";
  else if (/Linux/i.test(userAgent)) os = "Linux";

  if (/Chrome/i.test(userAgent)) browser = "Chrome";
  else if (/Firefox/i.test(userAgent)) browser = "Firefox";
  else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) browser = "Safari";
  else if (/Edge/i.test(userAgent)) browser = "Edge";
  else if (/Opera|OPR/i.test(userAgent)) browser = "Opera";

  if (/Mobi|Android/i.test(userAgent)) deviceType = "Mobile";
  else if (/Tablet|iPad/i.test(userAgent)) deviceType = "Tablet";
  else deviceType = "Desktop";

  return { os, browser, deviceType };
};

export default getDeviceInfo;
